import { getHomeCurrencyForCountry } from "../utility/utilityFunctions";
import useAuthentication from "./useAuthentication";

const getBrowserCountry = () => {
  try {
    return new Intl.Locale(navigator.language).region ?? null;
  } catch {
    return null;
  }
};

// The currency to estimate foreign prices in: the user's country, else the
// browser's region (logged out, or no country on the account). Null when
// neither is a country we support, so no estimate shows.
export const useHomeCurrency = () => {
  const { currentUser } = useAuthentication();
  return getHomeCurrencyForCountry(currentUser?.country || getBrowserCountry());
};
